import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { LS2PAC_Utils } from "./Utils";
import { LS2KIDS_CONSTANTS } from "../../ls2kids/constants";
import { eResourceRedirect } from "../../../../js/main/eResourceRedirect";

export const ResourceUtils = (function ($) {
  var mapButtonForCopiesTableExt;
  var getMapButtonForCopiesTableExt = function () {
    if (!mapButtonForCopiesTableExt) {
      mapButtonForCopiesTableExt = TLCEXT.Template(
        '<td class="map"><a href="javascript:;" class="map" data-id="{id}">{languageUtil.map}</a></td>'
      );
    }
    return mapButtonForCopiesTableExt;
  };
  var displayNone = 'style="display: none;" aria-hidden="true" hidden';
  var fullDetailsSearchLink = TLCEXT.Template(
    '<a href="/#section=full-details-search?link={value}" class="searchLink" data-type="{linkType}" data-value="{linkValue}">{value}</a>'
  );
  var fullKidsDetailsSearchLink = TLCEXT.Template(
    '<a data-section="{section}" href="/kids#{searchUrl}?searchString={linkType}:%22{linkValue}%22" class="searchLink">{value}</a>'
  );
  var fullDetailsEResourceSearchLink = TLCEXT.Template(
    '<a href="{linkValue}" target="_blank">{value}</a>'
  );

  // The number of milliseconds in one day
  var ONE_DAY = 1000 * 60 * 60 * 24;

  var daysOverdue = function (dueDate) {
    //take the dueDate, set the time to 23:59:59
    var lastSecondDue = new Date(
      dueDate.getFullYear(),
      dueDate.getMonth(),
      dueDate.getDate(),
      23,
      59,
      59
    );
    return days_between(lastSecondDue);
  };

  var days_between = function (date2, date1 = new Date()) {
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date1_ms - date2_ms; //Math.abs(date1_ms - date2_ms);
    // Convert back to days and return
    var days = difference_ms / ONE_DAY;
    return Math.ceil(days);
  };

  var getCallNumberFromHolding = function (holding) {
    if (!holding?.shelfLocation) {
      return "";
    }
    return holding.shelfLocation.trim();
  };

  var getVolumeAndCopyFromHolding = function (holding) {
    if (!holding) {
      return "";
    }
    return (
      (holding.volume ? holding.volume + " " : "") +
        (holding.copy ? holding.copy + " " : "") +
        (holding.year ? holding.year : "")
    ).trim();
  };

  var getSerialsInfoFromHolding = function (holding) {
    if (!holding) {
      return "";
    }
    return holding.chronology.trim() + "<br/>" + holding.enumeration.trim();
  };

  var isOverdue = function (date) {
    var days = daysOverdue(date);
    return days > 0;
  };
  var getOverdue = function (date) {
    if (isOverdue(date)) {
      return "overdue";
    }
  };

  var getAuthorWithBy = function (resource, index) {
    if (resource.shortAuthor != null && resource.shortAuthor.length > 0) {
      return ApplicationData.language.by + " " + resource.shortAuthor;
    }
    return "";
  };

  var getAuthorWithByForMyAccountItem = function (dataItem, index) {
    if (dataItem.author !== "" && dataItem.author !== null) {
      return ApplicationData.language.by + " " + dataItem.author;
    }
    return "";
  };

  var getSourceUrl = function (item, source) {
    if (item && item.resource) {
      return (
        "#/resource/" +
        item.resource.id +
        "/details"
      );
    }
    return "javascript:void(" + Math.random() + ");";
  };

  return {
    getPartsInfo: function (resource, index) {
      if (
        !resource.holdings[index] ||
        resource.holdings[index].parts === null
      ) {
        return "";
      }
      return (
        '<span class="' +
        LS2PAC_CONSTANTS.CssClasses.parts +
        '">' +
        resource.holdings[index].parts +
        "</span>"
      );
    },
    getCollection: function (resource, index) {
      var collection = "";
      if (resource.holdingsInformations.length > 0) {
        if (resource.holdingForOnShelf) {
          collection = resource.holdingForOnShelf.collectionName;
        } else {
          collection = resource.holdingsInformations[0].collectionName;
          $.each(resource.holdingsInformations, function (index, holding) {
            if (holding.available === true) {
              collection = holding.collectionName;
              return false;
            }
          });
        }
      }
      return collection;
    },
    getCallNumber: function (resource) {
      var callNumber = "";
      if (resource.holdingsInformations.length > 0) {
        if (resource.holdingForOnShelf) {
          callNumber = getCallNumberFromHolding(resource.holdingForOnShelf);
        } else {
          callNumber = getCallNumberFromHolding(
            resource.holdingsInformations[0]
          );
          $.each(resource.holdingsInformations, function (index, holding) {
            if (holding.available === true) {
              callNumber = getCallNumberFromHolding(holding);
              return false;
            }
          });
        }
      }
      return callNumber;
    },
    getVolumeAndCopyForHolding: function (data, index) {
      var holding = data.holdings[index];
      return getVolumeAndCopyFromHolding(holding);
    },
    getCallNumberForHolding: function (data, index) {
      var holding = data.holdings[index];
      return getCallNumberFromHolding(holding);
    },
    getSerialsInfoForHolding: function (data, index) {
      var holding = data.holdings[index];
      return getSerialsInfoFromHolding(holding);
    },
    showGetAuthorWithBy: function (resource, index) {
      var author = getAuthorWithBy(resource, index);
      return !author.length ? displayNone : "";
    },
    getResourceListAuthorHeading: function (resource, index) {
      var author = getAuthorWithBy(resource, index);
      if (author.length > 0) {
        return "<h3>" + author + "</h3>";
      }

      return "";
    },
    getAuthorWithBy: getAuthorWithBy,
    getAuthorWithByHeadlingLink: function (resource, index) {
      var shortAuthor = getAuthorWithBy(resource, index);

      if (shortAuthor.length) {
        return (
          "<h3>" +
          '<a href="#section=search&term=' +
          resource.shortAuthor +
          '&page=0&sortKey=Relevancy&db=ls2pac&branchFilters=[]&facetFilters=[]"' +
          ' class="authorLink" data-index="' +
          index +
          '">' +
          shortAuthor +
          "</a>" +
          "</h3>"
        );
      }

      return "";
    },
    getListViewAuthorLink: function (dataItem, index) {
      var getAuthorForMyAccountItem = getAuthorWithBy(dataItem, index);
      if (getAuthorForMyAccountItem.length) {
        return "<h3>" + getAuthorForMyAccountItem + "</h3>";
      }

      return "";
    },
    getFlowViewAuthorLink: function (dataItem) {
      var getAuthorForMyAccountItem = getAuthorWithBy(dataItem);
      if (getAuthorForMyAccountItem.length) {
        var href =
          "#section=search&term=" +
          encodeURI(dataItem.shortAuthor) +
          "&page=0&sortKey=Relevancy&db=ls2pac&branchFilters=[]&facetFilters=[]";

        return (
          "<h3><a href=" +
          href +
          ' class="authorLink" data-index="' +
          dataItem.index +
          '">' +
          getAuthorForMyAccountItem +
          "</a></h3>"
        );
      }

      return "";
    },
    showDOMAuthorWithByForMyAccountItem: function (dataItem, index) {
      var getAuthorForMyAccountItem = getAuthorWithByForMyAccountItem(
        dataItem,
        index
      );
      if (getAuthorForMyAccountItem.length) {
        return "<h3>" + getAuthorForMyAccountItem + "</h3>";
      }

      return "";
    },
    showAuthorWithByForMyAccountItem: function (dataItem, index) {
      var getAuthorForMyAccountItem = getAuthorWithByForMyAccountItem(
        dataItem,
        index
      );
      return !getAuthorForMyAccountItem.length ? displayNone : "";
    },
    getAuthorWithByForMyAccountItem: getAuthorWithByForMyAccountItem,
    getAuthor: function (resource, index) {
      if (resource.shortAuthor !== "" && resource.shortAuthor !== null) {
        return resource.shortAuthor;
      }
      return "&nbsp;";
    },
    getTitle: function (resource, index) {
      if (resource.shortTitle !== "") {
        return resource.shortTitle;
      }
      return "&nbsp;";
    },
    getTitleOneLevelDeep: function (data, index) {
      var resource = data.resource;
      if (resource.shortTitle !== "") {
        return resource.shortTitle;
      }
      return "&nbsp;";
    },
    getReservesInfo: function (data, index) {
      var response = "";
      var reserveInfo = data.reserveInfos;

      for (var i = 0, length = reserveInfo.length; i < length; i++) {
        var currentReserveInfo = reserveInfo[i];
        response += '<li class="reserve">';
        if (
          currentReserveInfo.department &&
          currentReserveInfo.department.trim().length != 0
        ) {
          response +=
            "<h4>" +
            ApplicationData.language.department +
            ": <span>" +
            currentReserveInfo.department;
          if (
            currentReserveInfo.departmentComment &&
            currentReserveInfo.departmentComment.trim().length != 0
          ) {
            response += " - " + currentReserveInfo.departmentComment;
          }
          response += "</span></h4>";
        }
        if (
          currentReserveInfo.course &&
          currentReserveInfo.course.trim().length != 0
        ) {
          response +=
            "<h4>" +
            ApplicationData.language.course +
            ": <span>" +
            currentReserveInfo.course;
          if (
            currentReserveInfo.courseComment &&
            currentReserveInfo.courseComment.trim().length != 0
          ) {
            response += " - " + currentReserveInfo.courseComment;
          }
          response += "</span></h4>";
        }
        if (
          currentReserveInfo.instructorName &&
          currentReserveInfo.instructorName.trim().length != 0
        ) {
          response +=
            "<h4>" +
            ApplicationData.language.instructor +
            ": <span>" +
            currentReserveInfo.instructorName +
            "</span></h4>";
        }
        response += "</li>";
      }

      return response;
    },
    getCallAndCollection: function (resource) {
      if (parseInt(resource.rtype, 10) == 1) {
        var content = ResourceUtils.getCollection(resource);
        if (content.length > 0) {
          content += " - ";
        }
        content += ResourceUtils.getCallNumber(resource);
        if (content == "") {
          return "&nbsp;";
        }
        return content;
      }
      return "&nbsp;";
    },
    getFormatIcon: function (resource, index) {
      var returnImage = "";
      if (
        parseInt(resource.rtype, 10) == 1 &&
        resource.imageDisplays.length > 0
      ) {
        var imageDisplay = resource.imageDisplays[0];
        returnImage =
          '<img src="images/format/' +
          imageDisplay.imageName +
          '" alt="' +
          imageDisplay.imageType +
          '" />';
      } else if (parseInt(resource.rtype, 10) == 2) {
        returnImage =
          '<img src="images/format/rssFeedIcon16x16_format.png" alt="' +
          ApplicationData.language.rssFeedItem +
          '" />';
      }
      return returnImage;
    },

    hideIfNoHoldings: function (branchItem) {
      if (branchItem.holdings && branchItem.holdings.length > 0) {
        return "";
      }
      return displayNone;
    },

    hideIfNoTextualHoldings: function (branchItem) {
      if (branchItem.textualHoldings && branchItem.textualHoldings.length > 0) {
        return "";
      }
      return displayNone;
    },

    hideIfHoldsAreOff: function (data, index) {
      if (LS2PAC_Utils.showRequestButton(data)) {
        return "";
      }
      return displayNone;
    },
    hideIfAdmin: function (data, index) {
      if (LS2PAC_Utils.showDownloadButton()) {
        return "";
      }
      return displayNone;
    },
    hideIfJustTitleHoldsIsOff: function () {
      if (LS2PAC_Utils.showBulkRequestOption()) {
        return "";
      }
      return displayNone;
    },
    getIsRequestDisabled: function (data, index) {
      if (data && data.resource && data.resource.disableRequestButton) {
        return LS2PAC_CONSTANTS.CssClasses.disabled;
      } else {
        return "";
      }
    },
    hideIfDownloadable: function (data, index) {
      if (data && data.downloadable) {
        return displayNone;
      }
      return "";
    },
    // getRequestButtonText: function (data, index) {
    //   var resource = data.rtype ? data : data.resource;
    //   if (parseInt(resource.rtype, 10) !== 1) {
    //     return ApplicationData.language.viewSite;
    //   }
    //   //if its a regular downloadable OR it supports 3rd party checkouts AND its available to be checked out
    //   if (
    //     (resource.downloadable && resource.hasDownloadbleCheckouts != true) ||
    //     (resource.hasDownloadbleCheckouts && resource.eResourceHasAvailability)
    //   ) {
    //     if (!resource.availability) {
    //       if (
    //         !resource.canCheckout ||
    //         (resource.canCheckout && !resource.actionsEnabled)
    //       ) {
    //         return ApplicationData.language.checkDigitalLocations;
    //       }
    //     }
    //     return ApplicationData.language.download;
    //   }
    //   return ApplicationData.language.placeRequest;
    // },
    getEResourceAttributes: function (data, index) {
      var resource = data.rtype ? data : data.resource;
      if (resource.downloadable && resource.hasDownloadbleCheckouts) {
        return 'data-serviceType="' + resource.eResourceService + '"';
      }
      return "";
    },
    getRequestButtonActionClass: function (data, index) {
      var resource = data.rtype ? data : data.resource;
      if (parseInt(resource.rtype, 10) !== 1) {
        return LS2PAC_CONSTANTS.CssClasses.external;
      } else if (resource.downloadable) {
        if (resource.hasDownloadbleCheckouts) {
          return LS2PAC_CONSTANTS.CssClasses.eResource;
        }
        return LS2PAC_CONSTANTS.CssClasses.external;
      }
      return "request";
    },
    getRequestButtonLink: function (data, index) {
      var resource = data.rtype ? data : data.resource;
      if (
        resource.link &&
        resource.link.length > 0 &&
        resource.disableRequestButton != true &&
        resource.hasDownloadbleCheckouts != true
      ) {
        return 'href="' + resource.link + '" target="_blank"';
      }
      return 'href="javascript:void(0);"';
    },
    getAvailabilityLink: function (data, index) {
      if (
        data.downloadable &&
        data.link &&
        data.hasDownloadbleCheckouts != true
      ) {
        return 'href="' + data.link + '" target="_blank"';
      }

      return (
        'href="#/resource/' +
        data.id +
        '/details"'
      );
    },
    getAvailabilityBindClass: function (data, index) {
      if (
        data.downloadable &&
        data.link &&
        data.hasDownloadbleCheckouts != true
      ) {
        return "";
      }

      return LS2PAC_CONSTANTS.CssClasses.availabilityBindClass;
    },
    getAvailabilityLinkForHref: function (data, index) {
      if (
        data.downloadable &&
        data.link &&
        data.hasDownloadbleCheckouts != true
      ) {
        return data.link;
      }

      return "javascript:;";
    },
    getMoreOptionsLink: function (data, index) {
      if (data.downloadable && data.link) {
        return 'href="' + data.link + '" target="_blank"';
      }

      return 'href="javascript:;"';
    },
    hideIfVirtualShelfIsOff: function (resource, index) {
      if (ApplicationData.locationConfiguration.isVirtualShelfEnabled()) {
        return "";
      }
      return displayNone;
    },

    hideIfNotResourceType1: function (resource, index) {
      if (parseInt(resource.rtype, 10) !== 1) {
        return displayNone;
      }
      return "";
    },
    hideIfLDAP: function () {
      if (ApplicationData.locationConfiguration.isLDAPEnabled()) {
        return displayNone;
      }
      return "";
    },
    hideIfADFS: function () {
      if (ApplicationData.locationConfiguration.isADFSEnabled()) {
        return displayNone;
      }
      return "";
    },
    ezLoginDisplay: function (data) {
      if (data.user.local === false) {
        return displayNone;
      }
      return "";
    },
    hideIfNoBookings: function (resource, index) {
      if (ApplicationData.locationConfiguration.getAllowBookings()) {
        return "";
      }
      return displayNone;
    },
    getQuickInfoTags: function (resource, index) {
      var tagsString = "";
      var len = resource.tags.length;
      TLCLogger.log("getting tag info", resource.tags);
      $.each(resource.tags, function (index, tag) {
        TLCLogger.log("tag", tag);
        if (tag.blocked === false) {
          tagsString +=
            '<a href="javascript:;" class="tag">' +
            tag.data +
            "</a>" +
            (len > 1 && index < len - 1 ? ", " : "");
        }
      });
      return tagsString;
    },
    getResourceId: function (resource) {
      return resource.id;
    },
    getSeries: function (resource) {
      if (resource.mainSeries && resource.mainSeries !== "") {
        return TLCEXT.Template(
          "<h4>{languageUtil.series}: {resource.mainSeries}</h4>"
        ).populate(resource);
      }
      return "";
    },
    getReadingLevels: function (resource) {
      var arInfo = resource.acceleratedReader;
      var lexileInfo = resource.lexile;

      if (resource.resource) {
        if (!arInfo) {
          arInfo = resource.resource.acceleratedReader;
        }
        if (!lexileInfo) {
          lexileInfo = resource.resource.lexile;
        }
      }
      var response = "";
      var isLexileEnabled =
        ApplicationData.locationConfiguration.isLexileEnabled();
      var isAcceleratedReaderEnabled =
        ApplicationData.locationConfiguration.isAcceleratedReaderEnabled();

      if (isLexileEnabled) {
        if (
          lexileInfo &&
          lexileInfo.lexileDisplay &&
          lexileInfo.lexileDisplay !== ""
        ) {
          response += TLCEXT.Template(
            '{languageUtil.lexileMeasure}: <span class="lexile">{lexileDisplay}</span>'
          ).populate(lexileInfo);
          if (isAcceleratedReaderEnabled && arInfo && arInfo.bookLevel) {
            response += ", ";
          }
        }
      }
      if (isAcceleratedReaderEnabled) {
        if (arInfo && arInfo.bookLevel) {
          response += TLCEXT.Template(
            '{languageUtil.atosLevel}: <span class="atos">{bookLevel}</span>'
          ).populate(arInfo);
        }
      }
      if (response != "") {
        return "<h4>" + response + "</h4>";
      }
      return "";
    },
    getReadingLevelsForSearchResults: function (resource) {
      if (
        !ApplicationData.locationConfiguration.isReadingLevelEnabledInSearchResults()
      ) {
        return "";
      }
      return ResourceUtils.getReadingLevels(resource);
    },
    showIfDisplaySelectPickupLocation: function () {
      if (
        !ApplicationData.locationConfiguration.isDisplaySelectPickupLocation()
      ) {
        return displayNone;
      }

      return "";
    },
    hideReadingLevelInSearchResults: function () {
      if (
        !ApplicationData.locationConfiguration.isReadingLevelEnabledInSearchResults()
      ) {
        return displayNone;
      }

      return "";
    },
    getQuickInfoSeries: function (resource, index) {
      if (resource.mainSeries && resource.mainSeries !== "") {
        return TLCEXT.Template(
          '<dt>{languageUtil.series}:</dt><dd class="series">{resource.mainSeries}</dd>'
        ).populate(resource);
      }
      return "";
    },
    getMapButton: function (resource, index) {
      if (
        ApplicationData.locationConfiguration.getShowMap() &&
        parseInt(resource.rtype, 10) == 1
      ) {
        return TLCEXT.Template(
          '<a href="javascript:;" class="map">{languageUtil.map}</a>'
        ).populate(resource);
      }
      return "";
    },
    hideIfNoMap: function (resource) {
      if (
        ApplicationData.locationConfiguration.getShowMap() &&
        parseInt(resource.rtype, 10) == 1
      ) {
        return "";
      }
      return displayNone;
    },
    getHasMap: function (resource) {
      if (ApplicationData.locationConfiguration.getShowMap()) {
        return "map";
      }
      return "";
    },
    getMapButtonForCopiesTable: function (branch, index) {
      if (ApplicationData.locationConfiguration.getShowMap()) {
        return getMapButtonForCopiesTableExt().populate(branch.holdings[index]);
      }
      return "";
    },
    getQuickInfoTagsSection: function (resource, index) {
      if (
        resource.tags &&
        ApplicationData.locationConfiguration.allowTagging()
      ) {
        var len = resource.tags.length;
        if (len > 0) {
          return TLCEXT.Template(
            '<dt>{languageUtil.tags}:</dt><dd class="tags">{resourceUtil.getQuickInfoTags}</dd>'
          ).populate(resource);
        }
        return "";
      }
      return "";
    },
    getQuickInfoInitialSummary: function (resource, index) {
      if (resource.content !== "" && resource.content !== null) {
        return TLCEXT.Template(
          '<blockquote id="quickInfo_summary" class="multiline summary clearfix">{content}</blockquote>'
        ).populate(resource);
      }
      return '<blockquote id="quickInfo_summary" class="multiline summary clearfix"></blockquote>';
    },
    getPubDate: function (resource, index) {
      return resource &&
        resource.publicationDate &&
        resource.publicationDate.publicationDate
        ? "(" + resource.publicationDate.publicationDate + ")"
        : "";
    },
    getPublisher: function (resource, index) {
      if (resource.publicationInformations) {
        var publisher = "";
        $.each(resource.publicationInformations, function (index, publication) {
          publisher += publication.publisherName;
        });
        return publisher;
      }
      return "";
    },
    getPubDateOneLevelDeep: function (item) {
      var resource = item.resource;
      return ResourceUtils.getPubDate(resource);
    },
    getPublisherSection: function (resource, index) {
      if (
        resource.publicationInformations &&
        resource.publicationInformations.length > 0
      ) {
        return TLCEXT.Template(
          '<dt>{languageUtil.publisher}:</dt><dd class="publisher">{resourceUtil.getPublisher}</dd>'
        ).populate(resource);
      }
      return "";
    },
    getFullDetailsEntry: function (data, index) {
      var item = data.detailsValues[index];
      if (item.linkValue !== null && item.linkType == "eresource") {
        return fullDetailsEResourceSearchLink.populate(item);
      } else if (item.linkValue !== null && item.linkType !== null) {
        return fullDetailsSearchLink.populate(item);
      }
      // console.log({item})
      return item.value;
    },
    getKidsFullDetailsEntry: function (data, index) {
      var item = data.detailsValues[index];
      if (item.linkValue !== null && item.linkType == "eresource") {
        return fullDetailsEResourceSearchLink.populate(item);
      } else if (item.linkValue !== null && item.linkType !== null) {
        item.searchUrl = LS2KIDS_CONSTANTS.Urls.search;
        return fullKidsDetailsSearchLink.populate(item);
      }
      return item.value;
    },
    oddOrEven: function (data, index) {
      return (index + 1) % 2 == 0 ? "even" : "odd";
    },
    getDueDate: function (data, index) {
      var holding = data.holdings[index];
      if (
        holding.dueDate &&
        ApplicationData.globalConfiguration.globalSettings.showDueDateForItems
      ) {
        return (
          "<strong>" +
          ApplicationData.language.dueBack +
          " " +
          holding.dueDateString +
          "</strong>"
        );
      }
      return "";
    },
    displaySuggestions: function (data) {
      if (data.suggestions.length < 1) {
        return displayNone;
      }
      return "";
    },
    disableIfEmailNotEditable: function () {
      if (ApplicationData.locationConfiguration.getEmailEditable() == false) {
        return "disabled";
      }
      return "";
    },
    disableIfAddressNotEditable: function () {
      if (ApplicationData.locationConfiguration.getAddressEditable() == false) {
        return "disabled";
      }
      return "";
    },
    disableIfPhoneNumberNotEditable: function () {
      if (
        ApplicationData.locationConfiguration.getPhoneNumberEditable() == false
      ) {
        return "disabled";
      }
      return "";
    },
    getDaysRemainingForLoans: function (loan) {
      //this can be a loan or a loanInfo which have different names for the date property
      var dateValue = loan.dateAsMilliseconds || loan.dueDate;
      if (typeof dateValue == "string") {
        dateValue = dateValue.replace(/-/g, "/");
      }
      var date = new Date(dateValue);
      var returnText;
      var days = daysOverdue(date);
      if (days == 0) {
        returnText = ApplicationData.language.dueToday;
      } else if (days > 0) {
        returnText = ApplicationData.language.overdue;
      } else {
        returnText =
          Math.abs(days) + " " + ApplicationData.language.daysRemaining;
      }
      return returnText;
    },
    getRenewalsInfo: function (loan) {
      var renewalCountSpan =
        '<span id="' +
        loan.id +
        '_renewalCount">' +
        loan.renewalCount +
        "</span>";
      var returnText = ApplicationData.language.renewalCounter.replace(
        "%RENEWALCOUNT%",
        renewalCountSpan
      );
      returnText += ", ";
      if (loan.renewalLimit == null) {
        returnText += ApplicationData.language.renewalsUnlimited;
      } else {
        var renewalsLeft = loan.renewalLimit - loan.renewalCount;
        if (renewalsLeft < 0) {
          renewalsLeft = 0;
        }
        var renewalsLeftSpan =
          '<span id="' + loan.id + '_renewalsLeft">' + renewalsLeft + "</span>";
        returnText += ApplicationData.language.renewalsRemaining.replace(
          "%RENEWALSREMAINING%",
          renewalsLeftSpan
        );
      }
      return returnText;
    },
    getRenewalsInfoToPrint: function (loan) {
      if (!loan.downloadable) {
        var returnText = loan.renewalCount + " / ";
        if (loan.renewalLimit == null) {
          returnText += ApplicationData.language.renewalsUnlimited;
        } else {
          var renewalsLeft = loan.renewalLimit - loan.renewalCount;
          if (renewalsLeft < 0) {
            renewalsLeft = 0;
          }
          returnText += renewalsLeft;
        }
        return returnText;
      } else {
        return "";
      }
    },
    getDaysBetween: function (dueDate, dateNow) {
      return days_between(dueDate, dateNow);
    },
    getOverdueCardClass: function (data) {
      var date = new Date(data.patron.cardExpirationDate);
      return getOverdue(date);
    },
    getOverdueClass: function (loan) {
      var date = new Date(loan.date || loan.dueDate);
      var returnText;
      return getOverdue(date);
    },
    getHoldActionButton: function (hold) {
      // TODO handle action param
      var href = "/#/myaccount/holds?action=";
      if (hold.suspendUntilDate) {
        return TLCEXT.Template(
          '<a class="reactivate" href="' +
            href +
            'reactivateHold">{languageUtil.reactivate}</a>'
        ).populate(hold);
      }

      return TLCEXT.Template(
        '<a class="suspend" href="' +
          href +
          'suspendHold">{languageUtil.suspend}<input class="hideIt" aria-hidden="true" aria-label="hidden input" type="text" /></a>'
      ).populate(hold);
    },
    getJustHoldStatus: function (hold) {
      var returnText = "";
      switch (hold.status) {
        case "AR":
          returnText = TLCEXT.Template(
            '{languageUtil.status}: <span class="arrived">{languageUtil.arrived}</span>'
          ).populate(hold);
          break;
        case "T":
          returnText = TLCEXT.Template(
            '{languageUtil.status}: <span class="inTransit">{languageUtil.inTransit}</span>'
          ).populate(hold);
          break;
        case "PE":
          returnText = TLCEXT.Template(
            '{languageUtil.positionInQueue}: <span class="queueLength">{holdQueueLength}</span>'
          ).populate(hold);
          break;
      }
      return returnText;
    },
    getHoldStatus: function (hold) {
      var returnText = ResourceUtils.getJustHoldStatus(hold);
      if (hold.suspendUntilDate) {
        returnText = TLCEXT.Template(
          '<span>{languageUtil.status}:</span> <strong class="suspended">{languageUtil.suspended}</strong> <span class="pickupDate">{languageUtil.until}:</span> <strong class="pickupDate">{suspendUntilDateString}<a class="suspend" href="javascript:;">({languageUtil.change})<input class="hideIt" aria-hidden="true" aria-label="hidden input" type="text" /></a></strong>'
        ).populate(hold);
      }
      return returnText;
    },
    getSerialIssueInformation: function (hold) {
      var returnText = "";
      if (hold.resource && hold.resource.serial) {
        if (hold.chronology && hold.chronology.length > 0) {
          returnText += TLCEXT.Template(
            '<div class="chronology"><span>{languageUtil.chronology}:</span> <strong>{chronology}</strong></div>'
          ).populate(hold);
        }
        if (hold.enumeration && hold.enumeration.length > 0) {
          returnText += TLCEXT.Template(
            '<div class="enumeration"><span>{languageUtil.numbering}:</span> <strong>{enumeration}</strong></div>'
          ).populate(hold);
        }
      }
      return returnText;
    },
    getByDateLine: function (hold) {
      if (hold.status == "AR" && !hold.suspendUntilDate && hold.holdPickupBy) {
        return TLCEXT.Template(
          '{languageUtil.by} <strong class="pickupDate">{holdPickupByString}</strong>'
        ).populate(hold);
      }
    },
    hideIfHoldArrivedOrInTransit: function (hold) {
      if (
        (hold.status == "AR" || hold.status == "T") &&
        !hold.suspendUntilDate
      ) {
        return displayNone;
      }
      return "";
    },
    ecommerceBatchingEnabled: function (data) {
      if (
        ApplicationData.locationConfiguration.isEcommerceEnabled() == false ||
        ApplicationData.locationConfiguration.getCarlXWebEcommerceEnabled()
      ) {
        return displayNone;
      }
      return "";
    },
    ecommerceCompletelyOff: function (data) {
      if (
        ApplicationData.locationConfiguration.isEcommerceEnabled() == false &&
        ApplicationData.locationConfiguration.getCarlXWebEcommerceEnabled() ==
          false
      ) {
        return displayNone;
      }
      return "";
    },
    showLoginError: function (data) {
      if (!data.showErrorMessage) {
        return displayNone;
      }
      return "";
    },
    getLinkIfResourceAvailable: function (dataItem) {
      if (dataItem && dataItem.resource) {
        var href =
          "#/resource/" +
          dataItem.resource.id +
          "/details";
        return (
          '<a href="' +
          href +
          '" class="fullDetails" data-index="{index}">' +
          dataItem.title +
          "</a>"
        );
      }
      return dataItem.title;
    },
    getSavedSearchSort: function (savedSearch) {
      return ApplicationData.language[savedSearch.sortType];
    },
    getSavedSearchHasFacets: function (savedSearch) {
      if (!savedSearch.facetFilters || savedSearch.facetFilters.length == 0) {
        return displayNone;
      }
      return "";
    },
    getSavedSearchExpression: function (savedSearch) {
      if (savedSearch.advanced) {
        return "(" + ApplicationData.language.advancedSearch + ")";
      }
      return savedSearch.expression;
    },
    getSavedSearchFacetsData: function (savedSearch) {
      var data = "";
      if (savedSearch.facetFilters || savedSearch.facetFilters.length > 0) {
        $.each(savedSearch.facetFilters, function (index, facet) {
          data += facet.facetName + ": " + facet.facetValue;
          if (index < savedSearch.facetFilters.length - 1) {
            data += ", ";
          }
        });
      }
      return data;
    },
    getChangeContactInformationLink: function (data) {
      if (
        ApplicationData.locationConfiguration.getEmailEditable() === false &&
        ApplicationData.locationConfiguration.getAddressEditable() === false &&
        ApplicationData.locationConfiguration.getPhoneNumberEditable() === false
      ) {
        return "";
      }

      var href =
        "/#/myaccount/edit-contact-info";

      return (
        '<a href="' +
        href +
        '" class="quickLink" data-view="' +
        LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountSettings +
        '" data-subView="' +
        LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.contactInformation +
        '">' +
        ApplicationData.language.changeContactInformation +
        "</a>"
      );
    },
    getCurrentUrlHash: function () {
      return "/" + window.location.hash;
    },
    getChangePinLink: function (data) {
      if (
        ApplicationData.locationConfiguration.getPinEditable() === true &&
        ApplicationData.locationConfiguration.getUsePin() === true
      ) {
        var href =
          "/#/myaccount/edit-pin"
        return (
          '<a href="' +
          href +
          '" class="quickLink" data-view="' +
          LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountSettings +
          '" data-subView="' +
          LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.pin +
          '">' +
          ApplicationData.language.changeYourLibraryPin +
          "</a>"
        );
      }
      return "";
    },
    getEZUsernameEditLinks: function (data) {
      if (data.user && data.user.usernameSet) {
        var href = "/#/myaccount/";
        return (
          '<span class="ezLinks"><a href="' +
          href +
          'edit-username' +
          '" class="quickLink" data-view="' +
          LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountSettings +
          '" data-subView="' +
          LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.ezUsername +
          '">' +
          ApplicationData.language.updateEZUsernameQuickLink +
          "</a> " +
          ApplicationData.language.or +
          ' <a href="' +
          href +
          'edit-password' +
          '" class="quickLink"  data-view="' +
          LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountSettings +
          '" data-subView="' +
          LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.ezPassword +
          '">' +
          ApplicationData.language.updateEZPasswordQuickLink +
          "</a></span>"
        );
      }
      return "";
    },
    hideIfGoogleLinked: function (data) {
      if (data.patron && data.patron.googleId) {
        return displayNone;
      }
      return "";
    },
    hideIfGoogleNotLinked: function (data) {
      if (!(data.patron && data.patron.googleId)) {
        return displayNone;
      }
      return "";
    },
    hideIfGoogleOAuthDisabled: function (data) {
      if (data.user.local === false) {
        return displayNone;
      }
      if(ApplicationData.locationConfiguration.isADFSEnabled()){
        return displayNone;
      }
      if (!ApplicationData.locationConfiguration.isGoogleOauthEnabled()) {
        return displayNone;
      }
      return "";
    },
    hideIfOBRDisabled: function (data) {
      if (!ApplicationData.locationConfiguration.isObrEnabled()) {
        return displayNone;
      }
      return "";
    },
    hideIfShowDependentBorrowersDisabled: function (data) {
      if (!ApplicationData.locationConfiguration.showDependentBorrowers()) {
        return displayNone;
      }
      return "";
    },
    getEZUsernameOrLink: function (data) {
      if (data.user.usernameSet) {
        return data.user.username;
      }
      return (
        '<a href="/#/myaccount/create-username" class="setEZUsername">' +
        ApplicationData.language.createEZLogin +
        "</a>"
      );
    },
    getFeeInCurrency: function (fine) {
      return LS2PAC_Utils.convertPenniesToCurrency(fine.fee);
    },
    hideIfLoanHistoryNotSupported: function () {
      if (ApplicationData.supportedFunctionality.supportsLoanHistory == false) {
        return displayNone;
      }
      return "";
    },
    getShowBrowse: function () {
      if (ApplicationData.locationConfiguration.showBrowse() == false) {
        return displayNone;
      }
      return "";
    },
    hideIfRegisterOff: function () {
      if (ApplicationData.locationConfiguration.showRegisterLink() == false) {
        return displayNone;
      }
      return "";
    },
    getHelpUrl: function () {
      return ApplicationData.locationConfiguration.getHelpUrl();
    },
    getPrivacyUrl: function () {
      return window.tlcGoogleAnalyticsPrivacyURL;
    },
    getLogoLink: function () {
      var link =
        ApplicationData.locationConfiguration.getAlternateTimeoutPageUrl();
      if (
        !link ||
        link === "" ||
        ApplicationData.locationConfiguration.getUseAlternateTimeoutPage() ===
          false
      ) {
        link = "javascript:void(0);";
      }
      return link;
    },
    getLogoContent: function () {
      var logoUrl = ApplicationData.locationConfiguration.getMainLogoUrl();
      if (!logoUrl || logoUrl === "") {
        // NOTE: This should have a better fallback
        return "&nbsp;";
      } else {
        return '<img src="storedimage/' + logoUrl + '" alt="logo" />';
      }
    },
    getLibraryName: function () {
      var text = ApplicationData.locationConfiguration.getLibraryName();
      if (typeof text === "string" && text.length) {
        return (
          '<h1 id="header_LibraryName"><a href="{resourceUtil.getLogoLink}" class="logoLink" aria-label="Library name">' +
          text +
          "</a></h1>"
        );
      }
      return "";
    },
    showAudienceControl: function () {
      if (
        ApplicationData.locationConfiguration.showAudienceControl() == false
      ) {
        return displayNone;
      }
      return "";
    },
    showReservesControl: function () {
      if (ApplicationData.locationConfiguration.isReservesEnabled() == false) {
        return displayNone;
      }
      return "";
    },
    showReservedSearchLink: function () {
      if (
        ApplicationData.locationConfiguration.isReservesEnabled() &&
        !ApplicationData.locationConfiguration.areReadingLevelsEnabled()
      ) {
        return "";
      }
      return displayNone;
    },
    showReadingLevelSearchLink: function () {
      if (
        ApplicationData.locationConfiguration.areReadingLevelsEnabled() &&
        !ApplicationData.locationConfiguration.isReservesEnabled()
      ) {
        return "";
      }
      return displayNone;
    },
    showMultipleAdvancedSearchLinks: function () {
      if (
        ApplicationData.locationConfiguration.isReservesEnabled() &&
        ApplicationData.locationConfiguration.areReadingLevelsEnabled()
      ) {
        return "";
      }
      return displayNone;
    },
    showOneAdvancedSearchLink: function () {
      if (
        ApplicationData.locationConfiguration.isReservesEnabled() ||
        ApplicationData.locationConfiguration.areReadingLevelsEnabled()
      ) {
        return displayNone;
      }
      return "";
    },
    showAcceleratedReaderInfo: function (resource) {
      if (ApplicationData.locationConfiguration.isAcceleratedReaderEnabled()) {
        return "";
      }
      return displayNone;
    },
    showLexileInfo: function (resource) {
      if (ApplicationData.locationConfiguration.isLexileEnabled()) {
        return "";
      }
      return displayNone;
    },
    showAtosLevel: function (resource) {
      if (
        ApplicationData.locationConfiguration.isAcceleratedReaderEnabled() &&
        resource.acceleratedReader.bookLevel
      ) {
        return "";
      }
      return displayNone;
    },
    showArPoints: function (resource) {
      if (
        ApplicationData.locationConfiguration.isAcceleratedReaderEnabled() &&
        resource.acceleratedReader.arPoints
      ) {
        return "";
      }
      return displayNone;
    },
    showInterestLevel: function (resource) {
      if (
        ApplicationData.locationConfiguration.isAcceleratedReaderEnabled() &&
        resource.acceleratedReader.interestLevel
      ) {
        return "";
      }
      return displayNone;
    },
    showQuizNumber: function (resource) {
      if (
        ApplicationData.locationConfiguration.isAcceleratedReaderEnabled() &&
        ApplicationData.locationConfiguration.isQuizNumberEnabled() &&
        resource.acceleratedReader.quizNumber
      ) {
        return "";
      }
      return displayNone;
    },
    showLexileMeasure: function (resource) {
      if (
        ApplicationData.locationConfiguration.isLexileEnabled() &&
        resource.lexile.lexileDisplay
      ) {
        return "";
      }
      return displayNone;
    },
    showAvailabilityBranchInTmpl: function (data) {
      if (ResourceUtils.showAvailabilityBranch(data) == false) {
        return displayNone;
      }
      return "";
    },
    showAvailabilityBranch: function (data) {
      if (
        data.showBranch == false ||
        ApplicationData.locationConfiguration.showBranchLimitControl() == false
      ) {
        return false;
      }
      return true;
    },
    showshowEResourceHoldings: function (data) {
      if (data.showEResourceHoldings == false) {
        return displayNone;
      }
      return "";
    },
    showAvailabilityLinkInTmpl: function (data) {
      if (ResourceUtils.showAvailabilityLink(data) == false) {
        return displayNone;
      }
      return "";
    },
    showAvailabilityLink: function (data) {
      if (
        data.showLink == false ||
        ApplicationData.locationConfiguration.showBranchLimitControl() == false
      ) {
        return false;
      }
      return true;
    },
    showHoldingsTruncatedInTmpl: function (data) {
      if (!data.holdingsTruncated) {
        return displayNone;
      }
      return "";
    },
    showTextualHoldingsTruncatedInTmpl: function (data) {
      if (!data.textHoldingsTruncated) {
        return displayNone;
      }
      return "";
    },
    showReservesAvailabilityLink: function (data) {
      return data.showLink;
    },
    showMoreOptionsLink: function (data) {
      if (data.showMoreOptions == false) {
        return displayNone;
      }
      return "";
    },
    getStatusClassForCopiesTable: function (data, index) {
      var status = data.holdings[index];
      if (status.available) {
        return "available";
      }
      return "";
    },
    hidePinFieldIfUsePinIsOff: function () {
      if (ApplicationData.locationConfiguration.getUsePin()) {
        return "";
      }
      return displayNone;
    },
    hideIfStationLocationSet: function () {
      if (ApplicationData.locationConfiguration.isStationLocationSet()) {
        return displayNone;
      }
      return "";
    },
    hideIfStationLocationIsNotSet: function () {
      if (!ApplicationData.locationConfiguration.isStationLocationSet()) {
        return displayNone;
      }
      return "";
    },
    hideIfStationLocationSetAndNoOverride: function () {
      if (
        ApplicationData.locationConfiguration.isStationLocationSet() &&
        !ApplicationData.locationConfiguration.isDownloadNowOverrideSet()
      ) {
        return displayNone;
      }
      return "";
    },
    hideIfDownloadNowOverride: function () {
      if (ApplicationData.locationConfiguration.isDownloadNowOverrideSet()) {
        return displayNone;
      }
      return "";
    },
    hideStationLocationDownloadMessage: function (item) {
      if (
        !ApplicationData.locationConfiguration.isStationLocationSet() ||
        !item.resource ||
        (item.resource && !item.resource.downloadable) ||
        item.pushable ||
        ApplicationData.locationConfiguration.isDownloadNowOverrideSet()
      ) {
        return displayNone;
      }
      return "";
    },
    hideStationLocationMessageInCheckoutResponse: function (item) {
      if (
        !ApplicationData.locationConfiguration.isStationLocationSet() ||
        item.autoSync ||
        ApplicationData.locationConfiguration.isDownloadNowOverrideSet()
      ) {
        return displayNone;
      }
      return "";
    },
    hideIfSharingDisabled: function () {
      if (ApplicationData.locationConfiguration.getSharingEnabled() == false) {
        return displayNone;
      }
      return "";
    },
    hideIfPersonalInformationIsHidden: function () {
      if (
        ApplicationData.locationConfiguration.getPersonalInformationIsHidden()
      ) {
        return displayNone;
      }
      return "";
    },
    getIsRenewDisabled: function (item) {
      if (ApplicationData.locationConfiguration.getAllowRenewals() == false) {
        return displayNone;
      }
      return "";
    },
    getResourceImageLink: function (item) {
      return getSourceUrl(item, "image");
    },
    hideIfResourceIsNull: function (item) {
      if (!item.resource) {
        return displayNone;
      }
      return "";
    },
    hideIfNoRenewFunctionality: function (item) {
      //currently we hide the checkbox for eResources that are not "mackin" service as we have no functionality for renew
      if (
        !item.downloadable ||
        (item.downloadable && item.eresourceService == "mackin")
      ) {
        return "";
      }
      return displayNone;
    },
    hideIfNotDownloadable: function (item) {
      var resource = item.resource;
      if (resource && resource.downloadable) {
        return "";
      }
      return displayNone;
    },
    hideIfDownloadableEBook: function (item) {
      var resource = item.resource;
      if (resource && resource.downloadable) {
        return displayNone;
      }
      return "";
    },
    hideIfPushable: function (item) {
      if (item.pushable) {
        return displayNone;
      }
      return "";
    },
    hideIfNotRenewable: function (item) {
      if (item.renewable) {
        TLCLogger.log("Renewable", item);
        return "";
      }
      return displayNone;
    },
    hideIfNotReturnable: function (item) {
      if (item.loanCancelable) {
        TLCLogger.log("Returnable", item);
        return "";
      }
      return displayNone;
    },
    getEResourceURL: function (item) {
      if (item.formatInfo.length == 1 && !item.useRedirectForURL) {
        var service = item.eresourceService || item.service;
        var url = eResourceRedirect(
          item.itemId,
          service
        );
        return 'href="' + url + '" target="_blank"';
      }

      return 'href="javascript:;"';
    },
    getEResourceURLForIFrame: function (item) {
      var service = item.eresourceService || item.service;
      return eResourceRedirect(item.itemId, service);
    },
    getDownloadButtonClass: function (item) {
      var multipleFormats = item.formatInfo.length > 1;
      // If there is only one format but it needs to open in a redirect tab
      // OR if there are multiple formats to pick from, we want javascript to do this
      if (multipleFormats || item.useRedirectForURL) {
        return "eresource-download";
      }
      return "external";
    },
    getTargetForExternalLink: function (item) {
      var multipleFormats = item.formatInfo.length > 1;

      if (multipleFormats || item.useRedirectForURL) {
        return "";
      }
      return 'target="_blank"';
    },
    getDisplayCheckoutActions: function (item) {
      if (item.resource.downloadable && item.status == "AR") {
        return "";
      }
      return displayNone;
    },
    hideIfNotYetArrived: function (item) {
      if (item.status == "AR") {
        return "";
      }
      return displayNone;
    },
    getPushableMessage: function (item) {
      if (item.resource && item.resource.downloadable && item.pushable) {
        return "";
      }
      return displayNone;
    },
    hideIfAdvancedEResourcesAreOff: function (item) {
      if (window.hasAuthorizedEResources) {
        return "";
      }
      return displayNone;
    },
    hideIfRedirectLink: function (event) {
      if (event.useRedirectForUrl) {
        return displayNone;
      }
      return "";
    },
    hideLexileOptions: function () {
      if (!ApplicationData.locationConfiguration.isLexileEnabled()) {
        return displayNone;
      }
      return "";
    },
    hideAcceleratedReaderOptions: function () {
      if (!ApplicationData.locationConfiguration.isAcceleratedReaderEnabled()) {
        return displayNone;
      }
      return "";
    },
    hideQuizNumber: function () {
      if (!ApplicationData.locationConfiguration.isQuizNumberEnabled()) {
        return displayNone;
      }
      return "";
    },
    getMessageToken: function (messageTokenString) {
      return messageTokenString.replace(/</g, "").replace(/>/g, "");
    },
    getMessageByMessageTokenString: function (messageTokenString, prefix) {
      prefix = prefix || "";
      var message =
        ApplicationData.language[
          prefix + this.getMessageToken(messageTokenString)
        ];
      return message === undefined ? messageTokenString : message;
    },
    showIfOnlyOneFormat: function (data) {
      if (data.eResourceFormats.length == 1) {
        return "";
      }
      return displayNone;
    },
    hideIfOnlyOneFormat: function (data) {
      if (data.eResourceFormats.length == 1) {
        return displayNone;
      }
      return "";
    },
    getFormatIfOnlyOne: function (data) {
      if (data.eResourceFormats.length == 1) {
        return data.eResourceFormats[0].formatName;
      }
    },
    getADFSLogoutUrl: function (data) {
      return ApplicationData.locationConfiguration.getADFSLogoutUrl();
    },

    getKidsMessageByMessageTokenString: function (messageTokenString, data) {
      var currentUser = ApplicationData.getCurrentUser();

      var types = {
        SMILE: ResourceUtils.getSmileIcon(),
        FROWN: ResourceUtils.getFrownIcon(),
      };

      var map = {
        YouDidIt: types.SMILE,
        eResourceSuccessDownloadBlocked: types.SMILE,

        eResourceInvalidEmailMessage: types.FROWN,
        PatronDoesNotHaveAgencyTypeToken: types.FROWN,
        OhNoYouOwe: types.FROWN,
        Oops: types.FROWN,
        Sorry: types.FROWN,
        ProhibitedByGuardianMessage: types.FROWN,
        TitleAlreadyOnHoldToken: null,
        eResourceAlreadyCheckedOutErrorMessage: null,
        placeHoldOnArrivedHoldErrorMessage: null,
        eResourceExpiredCardMessage: null,
        eResourcePushableMessage: null,
        eSuccessDownloadBlocked: null,
      };

      var prefix = "";

      if (map[messageTokenString]) {
        prefix = map[messageTokenString] + " ";
      }

      var message = ResourceUtils.getMessageByMessageTokenString(
        messageTokenString,
        "kids"
      );

      if (currentUser.firstName) {
        message = message.replace("%NAME%", currentUser.firstName);
      }

      message = ResourceUtils.getPlaceHoldInfoFailureMessage(message, data);

      return prefix + message;
    },
    getPlaceHoldInfoFailureMessage: (message, placeHoldInfo) => {
      if (placeHoldInfo.guardiansBlocking?.length > 0) {
        // note do not use ${name} the build process will replace it with LS2PAC 2.x
        const guardianList = placeHoldInfo.guardiansBlocking
          .sort()
          .map((guardianName) => `<li>${guardianName}</li>`)
          .join("");
        message = `
					<p>${message}</p>
					<ul style="list-style: none;">${guardianList}</ul>
				`;
      }

      return message;
    },
    /**
     *
     * @param {Array.<String>|String...} messageToken
     * @param {Object=} opts
     * @returns {string}
     */
    getKidsMessageForScout: function (messageToken, opts) {
      var messageTokens = Array.prototype.slice.call(arguments);

      if (arguments.length === 1) {
        if (Array.isArray(arguments[0])) {
          messageTokens = arguments[0];
          messageTokens.push(null);
        } else {
          messageTokens = [arguments[0], null];
        }
      } else if (arguments.length == 2) {
        if (Array.isArray(arguments[0])) {
          messageTokens = arguments[0];
          messageTokens.push(arguments[1]);
        }
      }

      var options = messageTokens.pop(),
        message = "";

      // if there is no options and the last one is a string, then we put it back
      if (typeof options === "string") {
        messageTokens.push(options);
        options = {};
      }

      options = $.extend({}, options, {
        showFullMessage: true,
      });

      // only support full messages if we pass a single message token (usually from an availability fail)
      if (options.showFullMessage && messageTokens.length == 1) {
        var token = messageTokens[0];

        var fullMessageMap = {
          SuccessToken: ["YouDidIt", token],
          eResourceOverdueItemsMessage: [
            "Oops",
            token,
            "eResourceReturnPastDue",
          ],
          eResourceUnpaidFinesMessage: ["OhNoYouOwe", token],
          eResourceExpiredCardMessage: [token, "SeeLibrarianToRenewCard"],
          eResourceAccountLockedMessage: [token, "PleaseSeeLibrarianForHelp"],
          eResourceInvalidUserMessage: [
            "Oops",
            token,
            "PleaseSeeLibrarianForHelp",
          ],
          eResourceInvalidEmailMessage: [token, token + "2", token + "3"],
          eResourceAlreadyCheckedOutErrorMessage: [
            token,
            "SeeWhatElseYouCanFind",
          ],
          eResourceSuccessDownloadBlocked: [
            token,
            "eResourceAskLibrarianWhenReady",
          ],
          checkoutEResourceErrorMessage: ["Oops", token, "PleaseTryAgainLater"],
          TitleAlreadyOnHoldToken: [token, token + "2"],
          eResourceHoldsSuccessMessage: ["YouDidIt", "SuccessToken"],
          TitleAlreadyCheckedOutToken: [token, "SeeWhatElseYouCanFind"],
          eResourceMaximumItemsCheckedOut: ["Sorry", token, token + "2"],
          placeHoldOnArrivedHoldErrorMessage: [
            token,
            "AndItsHereForYou",
            "SeeLibrarianToDownloadArrivedHold",
          ],
          eResourceNoFormatsMessage: ["Oops", token, "PleaseTryAgainLater"],
        };

        messageTokens = fullMessageMap[token] || [token];
      }

      for (var i = 0, length = messageTokens.length; i < length; i++) {
        var className = "";

        if (options && options.headline === i) {
          className = 'class="headline"';
        }
        message +=
          "<span " +
          className +
          ">" +
          ResourceUtils.getKidsMessageByMessageTokenString(
            messageTokens[i],
            options
          ) +
          "</span>";
      }

      return message;
    },
    getTokenFromEAvailability: function (eAvailability) {
      var messageToken = "checkoutEResourceErrorMessage";

      if (eAvailability.accountLocked) {
        messageToken = "eResourceAccountLockedMessage";
      } else if (eAvailability.checkedOut) {
        messageToken = "eResourceAlreadyCheckedOutErrorMessage";
      } else {
        if (eAvailability.invalidUser) {
          if (eAvailability.hasItemsOverdue) {
            messageToken = "eResourceOverdueItemsMessage";
          } else if (eAvailability.hasUnpaidFines) {
            messageToken = "eResourceUnpaidFinesMessage";
          } else if (eAvailability.hasExpiredCard) {
            messageToken = "eResourceExpiredCardMessage";
          } else {
            messageToken = "eResourceInvalidUserMessage";
          }
        } else {
          if (eAvailability.maxedOut) {
            messageToken = "eResourceMaximumItemsCheckedOut";
          }
        }
      }

      return messageToken;
    },
    hideIfDoNotAllowOnShelfHolds: function () {
      var onShelfHolds =
        ApplicationData.locationConfiguration.getAllowHolds().onShelf;

      if (!onShelfHolds) {
        return displayNone;
      }
      return "";
    },
    getFrownIcon: function () {
      return '<i class="fa-regular fa-face-frown"></i>';
    },
    getSmileIcon: function () {
      return '<i class="fa-regular fa-face-smile"></i>';
    },
    hideIfPaperNotificationOptionOff: function () {
			if (ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf("Paper") === -1) {
				return displayNone;
			}
			return "";
		},
		hideIfEmailNotificationOptionOff: function () {
			if (ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf("Email") === -1) {
				return displayNone;
			}
			return "";
		},
		hideIfPhoneNotificationOptionOff: function () {
			if (ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf("Phone") === -1) {
				return displayNone;
			}
			return "";
		},
		hideIfTextMessageNotificationOptionOff: function () {
			if (ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf("TextMessage") === -1) {
				return displayNone;
			}
			return "";
		},
    // getNotificationOptions: function (a, b) {
    //   var options = "";
    //   if (
    //     ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf(
    //       "Paper"
    //     ) !== -1
    //   ) {
    //     options +=
    //       '<option value="Paper">' +
    //       ApplicationData.language.ci_notificationType_Paper +
    //       "</option>";
    //   }

    //   if (
    //     ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf(
    //       "Email"
    //     ) !== -1
    //   ) {
    //     options +=
    //       '<option value="Email">' +
    //       ApplicationData.language.ci_notificationType_Email +
    //       "</option>";
    //   }

    //   if (
    //     ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf(
    //       "Phone"
    //     ) !== -1
    //   ) {
    //     options +=
    //       '<option value="Phone">' +
    //       ApplicationData.language.ci_notificationType_Phone +
    //       "</option>";
    //   }

    //   if (
    //     ApplicationData.globalConfiguration.borrowerNotificationTypes.indexOf(
    //       "TextMessage"
    //     ) !== -1
    //   ) {
    //     options +=
    //       '<option value="TextMessage">' +
    //       ApplicationData.language.ci_notificationType_TextMessage +
    //       "</option>";
    //   }

    //   return options;
    // },
    getSmsGateways: function (a, b) {
      var options = "";
      $.each(
        ApplicationData.globalConfiguration.smsGateways,
        function (index, carrier) {
          options +=
            '<option value="' +
            carrier.id +
            '">' +
            carrier.carrierName +
            "</option>";
        }
      );
      return options;
    },
    getCheckoutFormats: function (data) {
      var html = "<dt>";
      if (data.eResourceService === "bakertaylor") {
        html += ApplicationData.language.eResourceCheckoutFormatLabel;
      } else {
        html += ApplicationData.language.thisTitleIsAvailableAs;
      }
      html += "</dt>";

      if (
        data.eResourceService !== "bakertaylor" &&
        data.eResourceFormats &&
        data.eResourceFormats.length > 0
      ) {
        html +=
          '<input type="hidden" name="checkoutFormat" value="' +
          data.eResourceFormats[0].formatId +
          '" data-format="' +
          data.eResourceFormats[0].formatId +
          '"/>';
      }

      if (data.eResourceService === "bakertaylor") {
        $.each(data.eResourceFormats, function (index, format) {
          html += "<dd><label>";
          html +=
            '<input type="radio" name="checkoutFormat" value="' +
            format.formatId +
            '" data-format="' +
            format.formatId +
            '" selected="selected"/> ';
          html += format.formatName;
          html += "</label></dd>";
        });
      } else {
        html += "<ul>";
        $.each(data.eResourceFormats, function (index, format) {
          html += "<li>";
          html += format.formatName;
          html += "</li>";
        });
        html += "</ul>";
      }

      return html;
    },
  };
})(jQuery);
